// TODO: implement mute for specific layer and for specific audio
import $ from 'cash-dom';

export default class Sound {
    constructor(soundOpt, noSoundButton = false) {
        this.sound = {};
        this.backgrounds = [];
        this.effects = [];
        this.firstClick = false;
        this.mute = {
            "*": false,
            background: false,
            effect: false
        }
        this.currentSound = {
            background: undefined,
            effect: undefined
        }
        this.noSoundButton = noSoundButton;
        for (let key in soundOpt) {
            let src = soundOpt[key].src;
            let type = soundOpt[key].sub_type ? soundOpt[key].sub_type : "effect";
            if (type === "background") {
                this.backgrounds.push(key);
            } else {
                this.effects.push(key);
            }

            const audio = new Audio(src);
            if (type === "background") {
                audio.volume = 0.3;
            }
            this.sound[key] = {
                src: src,
                type,
                audio: audio
            };
            this.mute[key] = false;
        }
        if (this.backgrounds[0]) {
            this.currentSound.background = this.backgrounds[0];
        }
        this.init();
    }

    init() {
        // append sound button
        if (!$(".sound-control").length) {
            $("body").append(`
                <style>
                    .sound-control.off .sound-off {
                        display: inline;
                    }
                    .sound-control .sound-off {
                        display: none;
                        position: absolute;
                        top: 4px;
                        left: 5px;
                        font-size: 22px;
                    }
                    .sound-control.off .sound-on {
                        display: none;
                    }
                </style>
                <div style="position: fixed; bottom: 10px; right: 10px; color: #fff; z-index: 9999">
                    <div class="sound-control off" style="padding: 0;border-radius: 50%;background-color: rgba(128,128,128,0.5);width: 32px;height: 32px;line-height: 32px;text-align: center;font-size: 20px;">
                        <i class="wic-volume-mute2 sound-off"></i>
                        <i class="wic-volume-high sound-on"></i>
                    </div>
                </div>
            `);
        }
        if (this.noSoundButton) {
            $('.sound-control').css('display', 'none');
        }
        let self = this;
        $('.sound-control').on('click', () => {
            self.mute["*"] = !self.mute["*"];
            self.doMute();
        })
        // end append sound button

        // init mute
        let mute = localStorage.getItem('mute');
        if (mute) {
            this.mute = JSON.parse(mute);
        }
        this.doMute();
        // end init mute
        window.addEventListener("click", function (event) {
            if (!self.firstClick) {
                self.firstClick = true;
                self.playBackground();
            }
        })
        window.onbeforeunload = () => {
            this.pauseAll();
        };

    }

    doMute() {
        localStorage.setItem('mute', JSON.stringify(this.mute));
        if (this.mute["*"]) {
            $('.sound-control').addClass('off');
            this.pauseAll();
        } else {
            $('.sound-control').removeClass('off');
            this.playBackground();
        }
    }

    unMuteAll() {
        $('.sound-control').removeClass('off');
        this.mute['*'] = false;
        this.playBackground();
        localStorage.setItem('mute', JSON.stringify(this.mute));
    }
    muteAll() {
        $('.sound-control').addClass('off');
        this.mute['*'] = true;
        this.pauseAll();
        localStorage.setItem('mute', JSON.stringify(this.mute))
    }
    playBackground(key) {
        let sound = this.sound[key];
        if (sound && sound.type == "background") {
            this.currentSound.background = key;
        }
        this.stopBackground();
        if (this.mute["*"]) return;
        if (this.mute["background"]) return;
        sound = this.sound[this.currentSound.background || ''];
        sound.audio.volume = 0.2;
        sound && (sound.audio.loop = true) && this._playSound(sound.audio);
    }

    stopBackground() {
        for (let key of this.backgrounds) {
            this.sound[key].audio.pause();
        }
    }

    pauseAll() {
        for (let key of this.backgrounds) {
            this.sound[key].audio.pause();
        }
        for (let key of this.effects) {
            this.sound[key].audio.pause();
            this.sound[key].audio.currentTime = 0;
        }
    }

    selectBackground(key) {
        let sound = this.sound[key];
        if (sound && sound.type === "background") {
            this.currentSound.background = key;
        } else {
            this.currentSound.background = undefined;
        }
    }

    playEffect(key) {
        if (this.mute["*"]) return;
        if (this.mute["effect"]) return;
        if (this.mute[key]) return;

        let sound = this.sound[key];
        if (!sound) return;
        sound.audio.currentTime = 0;
        this._playSound(sound.audio);
    }

    stopEffect(key) {
        let sound = this.sound[key];
        if (!sound) return;
        sound.audio.pause();
    }

    _playSound(audio) {
        if (!audio) return;
        if (!audio.play) return;
        if (!this.firstClick) return;
        audio.play()
    }
}

export function createSound(Options, soundObj) {
    const { SETTINGS } = Options;
    // init sound
    let sound = soundObj;
    const DEFAULT_SOUND_SETTINGS = {
        background_audio: "https://cdn.jsdelivr.net/gh/woayst/common@1.6.4//sounds/cny-background.mp3",
        rolling_audio: "https://cdn.jsdelivr.net/gh/woayst/common@1.6.4//sounds/random-pick-8s.mp3",
        button_click_audio: "https://cdn.jsdelivr.net/gh/woayst/common@1.6.4//sounds-v2/common/button-click/O-Standard-1.mp3",
        award_audio: "https://cdn.jsdelivr.net/gh/woayst/common@1.6.4//sounds/kids-saying-yay.mp3",
    }
    const soundSettings = SETTINGS && SETTINGS.Sound || DEFAULT_SOUND_SETTINGS;
    if (!(sound instanceof Sound)) {
        let soundConfig = {};
        for (let key in soundSettings) {
            if (key.includes('background')) {
                soundConfig[key] = {
                    src: soundSettings[key],
                    sub_type: 'background',
                }
            } else {
                soundConfig[key] = {
                    src: soundSettings[key]
                }
            }
        }

        if (Options.no_sound) {
            sound = new Sound({});
        } else {
            sound = new Sound(soundConfig);
        }
    }
    return sound;
}